module.exports = __webpack_public_path__ + "static/media/ai-job-agent.33e36d53.webp";